
class MainNavigation {
  constructor(element, ...options) {
    this.defaults = {
      overlayWrapperSelector: '.js-nav-overlays',
      heightWrapperSelector: '.js-h-wrapper',
      menuOverlaySelector: '.js-nav-overlay-item',
      singleNavItemSelector: '.js-single-nav-item',
      menuOverlayTriggerSelector: '.js-open-nav-overlay',
      closeOverlayTriggerSelector: '.js-close-nav-overlay',
      toggleMainNavTriggerSelector: '.js-toggle-main-nav',
      activeClass: '-is-active',
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.menus = [];
    this.last = '';
    this.wrapper = document.querySelector(this.options.overlayWrapperSelector);
    this.heightWrapper = this.wrapper.querySelector(this.options.heightWrapperSelector);
    this.menuOverlayTriggers = [].slice.call(this.element.querySelectorAll(this.options.menuOverlayTriggerSelector));
    this.singleNavItems = [].slice.call(this.element.querySelectorAll(this.options.singleNavItemSelector));
    this.closeOverlayTriggers = [].slice.call(document.querySelectorAll(this.options.closeOverlayTriggerSelector));
    this.toggleMainNavTrigger = document.querySelector(this.options.toggleMainNavTriggerSelector);

    this.menuOverlayTriggers.forEach(function(element) {
      this.menus[element.id] = {
        active: false,
        trigger: element,
        overlay: document.querySelector(`${this.options.menuOverlaySelector}[data-target=${element.id}]`),
      }
    }.bind(this));

    this.bindEvents();
  }

  toggleMenu(event) {
    event.preventDefault();
    let targetMenu = this.menus[event.currentTarget.id];

    if(targetMenu.active) {
      this.closeMenu(targetMenu);
      this.last = '';
    } else {
      this.closeMenu(this.menus[this.last], false);
      this.openMenu(targetMenu);
      this.last = event.currentTarget.id;
    }
  }

  openMenu(target) {
    target.active = true;
    target.trigger.classList.add(this.options.activeClass);
    target.overlay.classList.add(this.options.activeClass);
    this.wrapper.classList.add(this.options.activeClass);
    if(!is_md_and_smaller()) {
      this.heightWrapper.style.minHeight = `${target.overlay.getBoundingClientRect().height}px`;
      this.wrapper.style.setProperty('--arrow-x', this.getArrowPos(target.trigger));
      document.documentElement.classList.add('no-scroll');
    }
  }

  closeMenu(target, allClosed = true) {
    if(target) {
      target.active = false;
      target.trigger.classList.remove(this.options.activeClass);
      target.overlay.classList.remove(this.options.activeClass);
      if(allClosed) this.wrapper.classList.remove(this.options.activeClass);
      if(!is_md_and_smaller()) {
        document.documentElement.classList.remove('no-scroll');
      }
    }
  }

  getArrowPos(trigger) {
    const pos = trigger.getBoundingClientRect();
    return `${(pos.left + pos.width/2) - this.wrapper.getBoundingClientRect().left}px`;
  }

  handleCloseTrigger() {
    this.closeMenu(this.menus[this.last]);
    this.last = '';
  }

  toggleMainNav(event) {
    if(this.element.classList.contains(this.options.activeClass)) {
      this.handleCloseTrigger(event);
    }

    this.element.classList.toggle(this.options.activeClass);
    this.toggleMainNavTrigger.classList.toggle(this.options.activeClass);
    document.documentElement.classList.toggle('no-scroll');
  }

  bindEvents() {
    if (!is_md_and_smaller()) {
      this.menuOverlayTriggers.forEach(function(trigger) {
        trigger.addEventListener('mouseenter', this.toggleMenu.bind(this));
      }.bind(this));

      this.singleNavItems.forEach(function(trigger) {
        trigger.addEventListener('mouseenter', this.handleCloseTrigger.bind(this));
      }.bind(this));
    }

    this.wrapper.addEventListener('mouseleave', this.handleCloseTrigger.bind(this));

    this.closeOverlayTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', this.handleCloseTrigger.bind(this));
    }.bind(this));

    document.querySelector('main.site').addEventListener('click', this.handleCloseTrigger.bind(this));

    if(is_md_and_smaller()) {
      this.toggleMainNavTrigger.addEventListener('click', this.toggleMainNav.bind(this));

      this.menuOverlayTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', this.toggleMenu.bind(this));
      }.bind(this));

      this.singleNavItems.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          location.href = e.target.querySelector('a').href;
        }.bind(this));
      }.bind(this));
    }
  }
}
